module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "P_Heading_1"
  }, [_c('span', [_vm._v("Excerpt")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "1.50em"
    }
  }, [_vm._v("B")]), _vm._v("ack. Go "), _c('i', [_vm._v("back")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text"
  }, [_vm._v("I knew where Lucas was. Or at least, where he was headed. Back home. From where we’d come from. Maybe, if I left now, I could catch him on the road. Maybe…")]), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text"
  }, [_vm._v("A part of my brain wanted to focus on the "), _c('i', [_vm._v("he loves you so much")]), _vm._v(". I wouldn’t let it. Not until I found Lucas and knew he was safe. Whatever he was going to do, we could do it together. He wasn’t going to do it alone. He didn’t need to. I was with him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text"
  }, [_vm._v("In every way, I was with him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text"
  }, [_c('i', [_vm._v("He loves you so much")]), _vm._v(". Huh, who knew the feeling was entirely mutual?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text"
  }, [_vm._v("“Veronica,” Lila Winchester said my name like it was a warning. “Please don’t be thinking you can save—”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text"
  }, [_vm._v("“Thanks, Doc,” I cut her off. “I’ll take a knife instead.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text"
  }, [_vm._v("I replaced the phone’s handset to its cradle before she could respond, hurried to the stainless steel knife block and yanked out the biggest. The same knife I’d first selected last time Lucas had gone AWOL in this house.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text"
  }, [_vm._v("The butcher’s knife was at least ten inches long and wickedly scary looking. It was perfect. Let’s see Officer Dewey and or Detective Kitchner come at me when I was wielding this.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text"
  }, [_vm._v("Knife in hand, I sprinted upstairs and grabbed a pair of jeans, a T-shirt and a pair of Chucks from the massive walk-in closet.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text"
  }, [_vm._v("It took me less than seventy-five seconds to get dressed. I counted each one, a desperate fear Lucas was going to get himself killed over me building inside me. By the time I tied my last lace, my hands were shaking.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text"
  }, [_vm._v("But I was angry. Seriously pissed.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text"
  }, [_vm._v("When I caught up with him, we were going to have a very long chat about making me worry. And then I was going to climb him like a pole and ride him like a pony until we both came screaming.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text"
  }, [_vm._v("Yes, I was that angry I’d resorted to tired clichés and mixed metaphors. Sue me.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text"
  }, [_vm._v("Dressed for ass kicking, I picked up the knife and then ran down the stairs. If I was really "), _c('i', [_vm._v("really")]), _vm._v(" lucky, Lucas would have left the Ferrari in the garage. Surely whatever misguided mission he was on required stealth?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text"
  }, [_vm._v("I didn’t need stealth right now. I needed speed. I needed to catch him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text"
  }, [_vm._v("Stop him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text"
  }, [_vm._v("I needed—")]), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text"
  }, [_vm._v("A soft thudding noise sounded near the front door.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text"
  }, [_vm._v("My heart smashed up into my throat in one swift leap.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text"
  }, [_vm._v("Lucas. Had to be. With the security at this place, who else could it be?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text"
  }, [_vm._v("Knife still in hand, I ran to the door and pulled it open.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text"
  }, [_vm._v("I froze at the sight of the tall, beefy man with the most porn-star moustache I’ve ever seen standing on the other side.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34a0e764","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0001.vue
// module id = 60
// module chunks = 0